import * as XLSX from 'xlsx';
import { templateConfig } from '../config/UploadConstant';

export function downloadUploadTemplate(uploaderKey, format) {
    const data = templateConfig[uploaderKey]?.[format];
    if (!data) return false;

    let blob;
    let filename;

    if (format === 'csv') {
        const csv = data.map((row) => row.join(',')).join('\n');
        blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        filename = `${uploaderKey}_template.csv`;
    } else if (format === 'excel') {
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        filename = `${uploaderKey}_template.xlsx`;
    } else {
        return false;
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    try {
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
    } finally {
        link.remove();
        URL.revokeObjectURL(url);
    }
    return true;
}
